import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

type GroupingOption = 'partner' | 'entity' | 'route' | 'bus' | 'partner_entity_route';
type ReportTypeOption = 'integrated' | 'bank_file' | 'invoice_reconciliation' | 'liquidation_by_route';

export interface SummaryDialogResult {
  grouping: GroupingOption;
  reportType: ReportTypeOption;
}

@Component({
  selector: 'app-summary-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatRadioModule, MatFormFieldModule, MatInputModule, MatIconModule, MatSelectModule],
  templateUrl: './summary-dialog.html'
})
export class SummaryDialog {
  grouping: GroupingOption = 'partner';
  reportType: ReportTypeOption = 'integrated';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { liquidation: { id: string; week: number; year: number } },
    private dialogRef: MatDialogRef<SummaryDialog, SummaryDialogResult | undefined>
  ) {}

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onConfirm(): void {
    this.dialogRef.close({ grouping: this.grouping, reportType: this.reportType });
  }
}
